export function Footer() {
  return (
    <footer className="bg-steel-900 text-white/75">
      <div className="container-x py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo/sobacov_badge.svg?v=officialred4hook" alt="" className="h-14 w-14 object-contain" />
            <div className="leading-tight">
              <div className="font-semibold text-white uppercase tracking-wider">Sobáčov</div>
              <div className="text-[10px] tracking-[0.20em] text-white/55 uppercase mt-1">
                Fishing &amp; Sport Resort
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/75">
            Sportovní areál v CHKO Litovelské Pomoraví. Rodinný penzion, rybářské chatky,
            glamping a catering na míru.
          </p>
        </div>

        <FooterCol title="Areál">
          {[
            { l: 'O areálu', h: '#o-arealu' },
            { l: 'Ubytování', h: '#ubytovani' },
            { l: 'Volný čas · sport', h: '#volny-cas' },
            { l: 'Galerie', h: '#galerie' },
            { l: 'Akce a nabídky', h: '#nabidky' },
            { l: 'Brigády', h: '#brigady' },
          ]}
        </FooterCol>

        <FooterCol title="Rezervace">
          {[
            { l: 'Rezervovat pobyt', h: '#rezervace' },
            { l: 'Pravidla rezervace · sport', h: '#pravidla' },
            { l: 'Pravidla rybolovu', h: '#pravidla-rybolov' },
            { l: 'Příjezd & odjezd', h: '#info-prijezd' },
            { l: 'Celkový ceník', h: '#info-cenik' },
            { l: 'Ubytovací řád', h: '#info-rad' },
            { l: 'Obchodní podmínky', h: '#podminky' },
            { l: 'Platební a dodací podmínky', h: '#info-platba' },
            { l: 'Reklamační řád', h: '#info-reklamace' },
            { l: 'Ochrana osobních údajů (GDPR)', h: '#gdpr' },
            { l: 'Časté dotazy', h: '#info-faq' },
            { l: 'Dárkové vouchery', h: '#koupit-voucher' },
          ]}
        </FooterCol>

        <div>
          <h4 className="text-white/55 font-semibold uppercase tracking-[0.16em] text-[11px] mb-4">Kontakt</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li>Sobáčov 111, 783 21 Mladeč</li>
            <li>
              <a href="tel:+420775140705" className="hover:text-white transition-colors">+420 775 140 705</a>
              <span className="text-white/50"> · recepce</span>
            </li>
            <li>
              <a href="tel:+420775433401" className="hover:text-white transition-colors">+420 775 433 401</a>
              <span className="text-white/50"> · rybolov</span>
            </li>
            <li>
              <a href="mailto:rezervace.sobacov@gmail.com" className="hover:text-white break-all transition-colors">
                rezervace.sobacov@gmail.com
              </a>
            </li>
            <li className="pt-2 flex gap-3">
              <a href="https://www.instagram.com/sobacov" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
                Instagram
              </a>
              <a href="https://www.facebook.com/sobacov" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
                Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Loga plateb — požadavek Comgate (5. 11. 2026): Comgate + Visa + Mastercard v patičce */}
      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-wrap items-center gap-x-7 gap-y-3">
          <span className="text-[11px] uppercase tracking-[0.16em] text-white/55 font-semibold">Bezpečné platby</span>
          <a href="https://www.comgate.eu/cs/platebni-brana" target="_blank" rel="noopener" title="Platební brána Comgate" className="opacity-90 hover:opacity-100">
            <img src="/platby/comgate-bile.svg" alt="Comgate" className="h-6 w-auto" />
          </a>
          <img src="/platby/visa-bile.svg" alt="Visa" className="h-11 w-auto -my-3" />
          <img src="/platby/mastercard.svg" alt="Mastercard" className="h-7 w-auto" />
          <a href="/#info-platba" className="text-[11px] text-white/55 hover:text-white underline">Platební podmínky</a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-5 text-[11px] text-white/55 flex flex-col md:flex-row justify-between gap-2">
          <div>
            Provozovatel: <b className="text-white/85">STALAGMIT, a.s.</b> · IČ 27377342 · DIČ CZ27377342 ·
            Varšavská 715/36, 120 00 Praha 2
          </div>
          <div>© {new Date().getFullYear()} NFI AI IQ — Robin Látal</div>
        </div>
      </div>
    </footer>
  )
}

function FooterCol({ title, children }: { title: string; children: { l: string; h: string }[] }) {
  return (
    <div>
      <h4 className="text-white/55 font-semibold uppercase tracking-[0.16em] text-[11px] mb-4">{title}</h4>
      <ul className="space-y-2 text-sm">
        {children.map((c) => (
          <li key={c.l}>
            <a href={c.h} className="hover:text-white transition-colors">
              {c.l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
